import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	optionsStatus: 'idle',
	options: null,
	optionsError: null
};

const qaAutomationSlice = createSlice({
	name: 'qaAutomation',
	initialState,
	reducers: {
		setOptionsStatus(state, action) {
			state.optionsStatus = action.payload || 'idle';
		},
		setOptions(state, action) {
			state.options = action.payload || null;
		},
		setOptionsError(state, action) {
			state.optionsError = action.payload || null;
		}
	}
});

export const {
	setOptionsStatus,
	setOptions,
	setOptionsError
} = qaAutomationSlice.actions;

export const selectQAAutomationOptionsStatus = (state) => state.qaAutomation.optionsStatus;
export const selectQAAutomationOptions = (state) => state.qaAutomation.options;
export const selectQAAutomationOptionsError = (state) => state.qaAutomation.optionsError;

export default qaAutomationSlice.reducer;
